export const rootURI = (uri: string) => {
    if (!uri) {
        return ''
    }

    if (uri[0] !== '/') return `/${uri}`
    else return uri
}
